const request = {}

request.createRequest = function (params) {
  return {
    saleList: params.saleList,
    salePaymentDate: params.date,
    salePaymentMethodId: params.method.value,
    completeDate: params.completeDate
  }
}
export default { request }
